"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _StepItem = _interopRequireDefault(require("./StepItem"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Steps navigation component is generally used inside a modal to
 * guide users to filling out a form in logical and numbered steps.
 */
var Steps =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Steps, _React$Component);

  function Steps() {
    _classCallCheck(this, Steps);

    return _possibleConstructorReturn(this, _getPrototypeOf(Steps).apply(this, arguments));
  }

  _createClass(Steps, [{
    key: "renderStepItems",

    /**
     * Construct the Step items of the navigation bar.
     *
     * @returns {Array} - array of StepItem
     */
    value: function renderStepItems() {
      var _this$props = this.props,
          data = _this$props.data,
          current = _this$props.current,
          onStepChange = _this$props.onStepChange;
      var stepItems = [];
      data.forEach(function (stepItem, index) {
        /**
         * status is calculated based on the current process step.
         * All items before current step are marked as 'finish' and
         * all items after current step are marked as 'wait'
         */
        var status = _StepItem.default.STATUS.PROCESS;
        var onClick;

        if (index < current) {
          status = _StepItem.default.STATUS.FINISH;

          if (onStepChange) {
            onClick = function onClick() {
              onStepChange(index, stepItems);
            };
          }
        } else if (index > current) {
          status = _StepItem.default.STATUS.WAIT;
        }

        var itemProps = _objectSpread({
          key: index,
          stepNumber: index + 1,
          status: status,
          onClick: onClick,
          hover: !!onStepChange
        }, stepItem);

        stepItems.push(_react.default.createElement(_StepItem.default, itemProps));
      });
      return stepItems;
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props2 = this.props,
          className = _this$props2.className,
          data = _this$props2.data,
          current = _this$props2.current,
          onStepChange = _this$props2.onStepChange,
          props = _objectWithoutProperties(_this$props2, ["className", "data", "current", "onStepChange"]);

      var itemSpacing = this.props.flexDirection === 'column' ? '20px' : '30px';
      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-steps")),
        itemSpacing: itemSpacing,
        justifyContent: "center"
      }, props), this.renderStepItems());
    }
  }]);

  return Steps;
}(_react.default.Component);

exports.default = Steps;
Steps.StepItem = _StepItem.default;
Steps.defaultProps = {
  data: []
};
Steps.propTypes = {
  /**
   * Array of steps data to generate the steps.
   */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Title of the step item.  If this is a string the component
     * will handle the styling properly for the various types and
     * appearances.  For other node type it is up to the application
     * to style it appropriately.
     */
    title: _propTypes.default.node,

    /**
     * A suffix display next to the title.
     * This is often used to display informational icons
     * with tooltip message.
     */
    titleSuffix: _propTypes.default.node,

    /**
     * This is the step number node prefixed to the title.
     * By default the component automatically fill this
     * starting at step 1 using the array index.
     * Defining this node will override
     * the auto fill feature.
     */
    stepNumber: _propTypes.default.node,

    /**
     * By default the component properly set the status
     * based on the props.current.  However this is available
     * for customization.
     */
    status: _propTypes.default.oneOf([_StepItem.default.STATUS.FINISH, _StepItem.default.STATUS.PROCESS, _StepItem.default.STATUS.WAIT])
  })),

  /**
   * The current process step number, counting from 0.
   */
  current: _propTypes.default.number,

  /**
   * Callback when a new step is clicked on.
   * If this is defined then previous step navigation is
   * enabled.
   */
  onStepChange: _propTypes.default.func
};